"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Status = function Status(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      color = _ref.color,
      reversed = _ref.reversed;
  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: statusCSS({
      reversed: reversed
    })
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: statusIconCSS({
      color: color
    })
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_.Spacer, null), /*#__PURE__*/_react["default"].createElement(_.Text, {
    diffuse: true
  }, label));
};

exports.Status = Status;

var statusCSS = function statusCSS(_ref2) {
  var reversed = _ref2.reversed;
  return function () {
    return {
      display: 'flex',
      alignItems: 'center',
      flexDirection: !reversed ? 'row' : 'row-reverse'
    };
  };
};

var statusIconCSS = function statusIconCSS(_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? 'body' : _ref3$color;
  return function (_ref4) {
    var colors = _ref4.theme.colors;
    return {
      color: colors[color]
    };
  };
};